import * as actions from './actions.js'
import * as getters from './getters.js'
import mutations from './mutations.js'

const state = {
  isLogined: false,
  user: {},
  token: null,
  menuTheme: ''
}

export default {
  state,
  actions,
  getters,
  mutations
}
